export default __webpack_public_path__ + "static/media/group.c1057b07.png";